import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { SupportedLanguagePairs } from '@utils/types/glossary';

export const useGetSupportedLanguagePairs = () => {
  const fetchSupportedLanguagePairs = async () => {
    const { data } = await Axios.get<SupportedLanguagePairs>(
      GET_URL().supportedLanguagePairs!
    );
    return data;
  };

  return useQuery<SupportedLanguagePairs, AxiosError<BaseError>>(
    ['supportedLanguagePairs'],
    fetchSupportedLanguagePairs,
    {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000 // 1 hour - this data rarely changes
    }
  );
};
